export default {
      id: "icon-letter-usage",
      viewBox: "0 0 38 27",
      url: __webpack_public_path__ + "icons.svg#icon-letter",
      toString: function () {
        return this.url;
      }
    }